import { Button, Checkbox, Group, Stack, Text } from "@mantine/core";
import { IconFileText } from "@tabler/icons-react";
import { useState } from "react";
import { ConflictOfInterestAck } from "./ConflictOfInterestAck";
import {
  TERMS_ACCEPTANCE_COPY,
  TERMS_VERSION,
  termsAgreeLabel,
  termsHeading,
  type RoleTerms,
} from "../constants/platformTerms";
import { usePlatformTermsModal } from "../context/usePlatformTermsModal";

interface Props {
  terms: RoleTerms;
  masterAccepted: boolean;
  onMasterAcceptedChange: (value: boolean) => void;
  conflictAccepted?: boolean;
  onConflictAcceptedChange?: (value: boolean) => void;
  version?: string;
  accent?: "violet" | "blue";
}

export function TermsAcceptancePanel({
  terms,
  masterAccepted,
  onMasterAcceptedChange,
  conflictAccepted = false,
  onConflictAcceptedChange,
  version = TERMS_VERSION,
  accent = "violet",
}: Props) {
  const { open } = usePlatformTermsModal();
  const [reviewed, setReviewed] = useState(false);

  function openTerms() {
    open({
      terms,
      version,
      accent,
      onReviewed: () => setReviewed(true),
    });
  }

  return (
    <Stack gap="md">
      {terms.conflictOfInterest && onConflictAcceptedChange && (
        <ConflictOfInterestAck
          copy={terms.conflictOfInterest}
          accepted={conflictAccepted}
          onAcceptedChange={onConflictAcceptedChange}
        />
      )}

      <Group justify="space-between" align="flex-start" wrap="wrap">
        <div>
          <Text fw="var(--axio-font-weight-bold)">{termsHeading(terms)}</Text>
          <Text size="sm" c="dimmed">
            {TERMS_ACCEPTANCE_COPY.versionPrefix} {version}
          </Text>
        </div>
        <Button
          variant="light"
          color={accent}
          leftSection={<IconFileText size="var(--axio-unit-16)" />}
          onClick={openTerms}
        >
          {TERMS_ACCEPTANCE_COPY.viewFullTerms}
        </Button>
      </Group>

      <Checkbox
        checked={masterAccepted}
        disabled={!reviewed}
        onChange={(event) => onMasterAcceptedChange(event.currentTarget.checked)}
        color={accent}
        label={reviewed ? termsAgreeLabel(terms, version) : TERMS_ACCEPTANCE_COPY.openToContinue}
      />
    </Stack>
  );
}
